<template>
  <div class="error-message" v-if="isErrorMessageOpen">
    <div class="error-message__box">
      <button class="error-message__button" @click="closeErrorMessage">
        <i class="icon-cancel"></i>
      </button>
      <div class="error-message__heading" v-text="langJson[lang].loginErrorHeader"></div>
      <div class="error-message__content" v-html="langJson[lang].loginErrorText"></div>
    </div>
    <div class="error-message__overlay" @click="closeErrorMessage"></div>
  </div>
</template>

<script>
  import { useMainStore } from '@/stores/main';
  import { storeToRefs } from 'pinia';

  export default {
    setup() {
      const mainStore = useMainStore();
      const { isErrorMessageOpen, lang, langJson } = storeToRefs(mainStore);
      return { isErrorMessageOpen, lang, langJson, mainStore };
    },
    methods: {
      // Use Pinia actions directly, e.g. this.mainStore.setIsErrorMessageOpen(value)
      closeErrorMessage() {
        this.mainStore.setIsErrorMessageOpen(false);
      }
    }
  };
</script>
